import { ImageFragment } from '@/graphql/fragments/image';
import { gql } from '@apollo/client';

export const FIND_USER_BY_ID = gql`
  query findUsersPermissionsUserById($id: ID!) {
    usersPermissionsUser(id: $id) {
      data {
        id
        attributes {
          username
          email
          provider
          confirmed
          blocked
          onboardHomeCompleted
          location
          forename
          surname
          confirmationEmailSent
          ageBracket
          gender
          onboardQuestionsCompleted
          isEmotionWheelTrackingDisabled
          onboardMindfulMinuteCompleted
          onboardEmotionWheelCompleted
          profile
          school {
            data {
              id
              attributes {
                name
                subscription {
                  data {
                    attributes {
                      name
                      dailyBubble
                      knowledgeHub
                      podcast
                      learn
                      meditation
                    }
                  }
                }
              }
            }
          }
          ws_permission {
            data {
              attributes {
                name
                isAdmin
                isMAT
                adminManagement
                reportingDashboard
                surveyDashboard
                meditation
                knowledgeHub
                announcements
              }
            }
          }
          school {
            data {
              attributes {
                subscription {
                  data {
                    attributes {
                      name
                      dailyBubble
                      knowledgeHub
                      podcast
                      learn
                      meditation
                    }
                  }
                }
              }
            }
          }
          createdAt
          photo {
            data {
              attributes {
                url
                alternativeText
              }
            }
          }
          topics {
            data {
              id
              attributes {
                topic
              }
            }
          }
        }
      }
    }
  }
`;

export const PROFILE_PAGE = gql`
  query profilePage {
    profilePage {
      data {
        attributes {
          welcomeTitle
          profileInfoSection {
            memberSinceTitle
            youLocationTitle
            editYourInfoCta
            saveYourChangesCta
            surnamePlaceholder
            forenamePlaceholder
          }
          profilePasswordSection {
            yourPasswordTitle
            yourCurrentPasswordField
            yourNewPasswordField
            confirmYourPasswordField
            confirmYourChangesCta
          }
          profileNotificationsSection {
            yourNotificationsTitle
            confirmYourChangesCta
          }
          profileThemesSection {
            yourFocusTitle
            whichAreasTitle
            confirmYouChangesCta
          }
          emotionTrackingSection {
            title
            btnStopTrackingLabel
            btnStartTrackingLabel
            notRecordedLabel
            notRecordedDescription
            notRecordedIcon {
              data {
                ...ImageFragment
              }
            }
            notTrackingIcon {
              data {
                ...ImageFragment
              }
            }
          }
          statsAndStreaks {
            finishingCardStreak {
              days
              title
            }
            finishingCardMaxStreak {
              days
              title
            }
            finishingCardEmotionWheel {
              emotions
            }
            finishingCardInsight {
              insights
            }
            finishingCardMindfulMinute {
              minutes
            }
          }
        }
      }
    }
  }
  ${ImageFragment}
`;

// export const FIND_NOTIFICATION_PREFERENCES_BY_USER_ID = gql`
//   query getNotificaitonPreferencesByUserId($userId: ID!) {
//     notificationPreferences(filters: { user: { id: { eq: $userId } } }) {
//       data {
//         id
//         attributes {
//           preferences {
//             type
//             value
//             time
//           }
//         }
//       }
//     }
//   }
// `;
